var $ = require('jquery');

$.QueryString = (function (paramsArray) {
    let params = {};

    for (let i = 0; i < paramsArray.length; ++i) {
        let param = paramsArray[i]
            .split('=', 2);

        if (param.length !== 2)
            continue;

        params[param[0]] = decodeURIComponent(param[1].replace(/\+/g, " "));
    }

    return params;
})(window.location.search.substr(1).split('&'));

$.QueryStringTabActivation = (function (tabName, tabCount) {
    var querystringValue = $.QueryString[tabName];
    if (querystringValue <= tabCount && $.QueryString[tabName] > 0) {
        return $.QueryString[tabName];
    }
    return 999;
});

$.AnimatedScroll = (function (position, duration) {
    $('html, body').animate({
        scrollTop: position
    }, duration);
});


$.ScrollToLocation = (function (object, duration, scrollToTab) {
    var hash = window.location.hash;
    var hashElement = document.getElementById(hash.replace('#', ''));

    if (hash && $.contains(object.get(0), hashElement)) {
        $.AnimatedScroll($(hash).offset().top - $('.header').height(), duration);
    }
    else if (scrollToTab){
        $.AnimatedScroll(object.offset().top - $('.header').height(), duration);
    }
});

